import _ from 'lodash'

export default ({
  currentUser: {
    userRoles,
  },
}) => (
  _.some(userRoles, {
    objectable: 'Site',
    role: {
      name: 'Admin',
    },
  })
)
